export default {
  container: {
    my: '1rem',
  },
  spinnerContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '70vh',
  },
  card: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  emptyCard: {
    flexDirection: 'column',
    justifyContent: 'center',
  },
  menuContainer: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  workshopContainer: {
    flex: 1,
    flexDirection: 'column',
  },
  grid: {
    gridTemplateColumns: ['repeat(1,1fr)', null, null, null, 'repeat(2,1fr)'],
    mt: '1rem',
  },
  settingsContainer: {
    mt: '1rem',
    flexDirection: 'column',
    alignSelf: 'center',
    width: ['100%', null, null, '80%', '70%', '60%', '50%'],
  },
  emptyContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  emptyText: {
    fontSize: 18,
  },
  loadingIndicator: {
    flex: 1,
    justifyContent: 'center',
    minHeight: '70vh',
    alignItems: 'center',
  },
};
